export const WORKSPACE_PLAN_STARTER_FREE = 'starter_free';
export const WORKSPACE_PLAN_BUSINESS = 'business';
export const WORKSPACE_PLAN_ENTERPRISE = 'enterprise';
export const WORKSPACE_PLAN_EDUCATION = 'education';

export const WORKSPACE_PLAN_DISPLAY_NAME_MAP = {
  [WORKSPACE_PLAN_STARTER_FREE]: 'Starter Free',
  [WORKSPACE_PLAN_BUSINESS]: 'Business',
  [WORKSPACE_PLAN_ENTERPRISE]: 'Enterprise',
  [WORKSPACE_PLAN_EDUCATION]: 'Education',
};

export const WORKSPACE_PLAN_INDEFINITE_ARTICLE_MAP = {
  [WORKSPACE_PLAN_STARTER_FREE]: 'a',
  [WORKSPACE_PLAN_BUSINESS]: 'a',
  [WORKSPACE_PLAN_ENTERPRISE]: 'an',
  [WORKSPACE_PLAN_EDUCATION]: 'an',
};

// from least pri to highest pri
export const ALL_WORKSPACE_PLANS = [
  WORKSPACE_PLAN_STARTER_FREE,
  WORKSPACE_PLAN_EDUCATION,
  WORKSPACE_PLAN_BUSINESS,
  WORKSPACE_PLAN_ENTERPRISE,
];

export const FREE_WORKSPACE_PLANS = [
  WORKSPACE_PLAN_EDUCATION,
  WORKSPACE_PLAN_STARTER_FREE,
];

export const TEAM_WORKSPACE_PLANS = [
  WORKSPACE_PLAN_BUSINESS,
  WORKSPACE_PLAN_ENTERPRISE,
];

export const WORKSPACE_PLAN_HIERARCHY = {
  [WORKSPACE_PLAN_STARTER_FREE]: 1,
  [WORKSPACE_PLAN_EDUCATION]: 1,
  [WORKSPACE_PLAN_BUSINESS]: 4,
  [WORKSPACE_PLAN_ENTERPRISE]: 5,
};

/**
 * If the enum begins with a verb (e.g. START_UPGRADE_TRIAL) that means the source is attributed
 * to the user or to an admin. If the enum ends with a passive verb (e.g. UPGRADE_TRIAL_ENDED) that
 * means the source is attributed to an event with an upstream source like Stripe or a scheduled
 * event.
 */
export const WORKSPACE_UPDATE_PLAN_SOURCE = {
  UNKNOWN: 'unknown',
  START_UPGRADE_TRIAL: 'start_upgrade_trial',
  UPGRADE_TRIAL_ENDED: 'upgrade_trial_ended',
  STRIPE_SUBSCRIPTION_DELETED: 'stripe_subscription_deleted',
  UPDATE_WORKSPACE_PLAN_MANUALLY: 'update_workspace_plan_manually',
  STRIPE_PLAN_CHANGED: 'stripe_plan_changed',
  UPGRADE: 'upgrade',
  SCHEDULE_DOWNGRADE: 'schedule_downgrade',
  FORCE_DOWNGRADE: 'force_downgrade',
  CREATE_NEW_WORKSPACE: 'create_new_workspace',
  EDU_VERIFICATION: 'edu_verification',
};
